<template>
  <div class="course-card">
    <div class="thumbnail-container">
      <div v-if="imageLoading" class="shimmer"></div>
      <img v-show="!imageLoading" :src="thumbnailBlobUrl" alt="Course Thumbnail" class="thumbnail" />
      <div v-if="progressStatus" class="progress-badge">{{ progressStatus }}</div>
      <div v-if="isVideoLesson" class="play-icon">
        <i class="fa fa-play"></i>
      </div>
      <div v-else-if="isCourse && isPaid && !hasSubscription" class="play-icon">
        <i class="fa fa-lock"></i>
      </div>

    </div>
    <div class="course-content">
      <h3 class="title">{{ title }}</h3>
      <p class="description">{{ truncatedDescription }}</p>
      <div class="meta">
        <span class="category">{{ category }}</span>
        <span class="level">{{ level }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    isCourse: {
      type: Boolean,
      required: true,
      default: false
    },
    isVideoLesson: {
      type: Boolean,
      required: true,
      default: false
    },
    thumbnail: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    category: {
      type: String,
      required: false
    },
    level: {
      type: String,
      required: false
    },
    progressStatus: {
      type: String,
      required: false,
      default: ''
    },
    isPaid: {
      type: Boolean,
      required: false,
      default: false
    },
    hasSubscription: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      thumbnailBlobUrl: null,
      imageLoading: true,
    };
  },
  computed: {
    truncatedDescription() {
      const words = this.description.split(' ');
      const maxWords = 30;
      if (words.length > maxWords) {
        return words.slice(0, maxWords).join(' ') + '...';
      }
      return this.description;
    }
  },
  methods: {
    async fetchThumbnailWithAuth() {
      this.revokeThumbnailBlob();
      this.imageLoading = true;
      try {
        const blobUrl = await this.$store.dispatch('fetchThumbnailWithAuth', {
          isCourse: this.isCourse,
          thumbnail: this.thumbnail
        });

        this.thumbnailBlobUrl = blobUrl;
        this.$nextTick(() => {
          const img = this.$el.querySelector('.thumbnail');
          if (img) {
            img.onload = () => { this.imageLoading = false; };
            img.onerror = () => { this.imageLoading = false; };
          } else {
            this.imageLoading = false;
          }
        });
      } catch (e) {
        this.thumbnailBlobUrl = null;
        this.imageLoading = false;
      }
    },
    revokeThumbnailBlob() {
      if (this.thumbnailBlobUrl) {
        URL.revokeObjectURL(this.thumbnailBlobUrl);
        this.thumbnailBlobUrl = null;
      }
    },
  },
  mounted() {
    this.fetchThumbnailWithAuth();
  }
}
</script>